module.exports = __webpack_public_path__ + "static/form2-7a1ea1dd537efeb32b44d549ba8baf29.png";